angular.module('octopusApp.tenants')
        .controller('TenantVariablesLayoutController', function($rootScope, tenantState, tabState) {
        this.tenantState = tenantState;
        this.tenantId = tenantState.tenantId;
        this.isLoading = tabState.isLoading;
        this.isSaving = tenantState.isSaving;
        this.showMissingVariablesMessage = function showMissingVariablesMessage() {
            if (!tenantState.missingVariables) {
                return false;
            }

            return (tenantState.missingVariables.isMissingLibraryVariable && $rootScope.layout.variableTab === 'library') ||
                (tenantState.missingVariables.isMissingProjectVariable && $rootScope.layout.variableTab === 'projects');
        };
    }).provider('tenantVariablesState', function() {
        this.$get = function($stateParams, busy, octopusRepository) {
            var state = {
                isLoading: busy.create(),
                isSaving: busy.create(),
                tenantId: $stateParams.tenantId,
                tenantIdAsync: null
            };

            function load() {
                state.tenantIdAsync = octopusRepository.Tenants.get(state.tenantId);
                state.isLoading.promise(state.tenantIdAsync.then(function (tenant) {
                    state.tenant = tenant;
                }));
                return state.tenantIdAsync;
            }

            state.load = load;
            return state;
        };
    });


//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/variables/tenant_variables_layout_controller.js
// module id = 1108247919981347
// module chunks = 1